module.exports = __webpack_public_path__ + "img/more_btn.f98cc816.jpeg";